/**
 * CelebrationOverlay - Global overlay for gamification celebrations
 *
 * Renders the appropriate celebration component based on the current
 * celebration type from GamificationContext.
 *
 * Place this component at the layout level to ensure celebrations
 * show above all other content.
 */

import React from 'react';
import { useGamification, CELEBRATION_TYPES } from '@/contexts/GamificationContext';
import LevelUpCelebration from './LevelUpCelebration';
import BadgeUnlockModal from './BadgeUnlockModal';
import StreakCelebration from './StreakCelebration';
import XPGainIndicator from './XPGainIndicator';

const CelebrationOverlay = () => {
  const {
    currentCelebration,
    celebrationVisible,
    dismissCelebration,
    recentXPGains,
    soundEnabled,
  } = useGamification();

  return (
    <>
      {/* Floating XP gain indicators */}
      {recentXPGains.map((gain) => (
        <XPGainIndicator
          key={gain.id}
          amount={gain.amount}
          position={gain.position}
        />
      ))}

      {/* Main celebration modals */}
      {currentCelebration && (
        <>
          {currentCelebration.type === CELEBRATION_TYPES.LEVEL_UP && (
            <LevelUpCelebration
              isOpen={celebrationVisible}
              onClose={dismissCelebration}
              newLevel={currentCelebration.data.newLevel}
              previousLevel={currentCelebration.data.previousLevel}
              levelTitle={currentCelebration.data.levelTitle}
              totalXP={currentCelebration.data.totalXP}
              onShare={(target, text) => {
                console.log(`[CelebrationOverlay] Share to ${target}:`, text);
              }}
            />
          )}

          {currentCelebration.type === CELEBRATION_TYPES.BADGE_EARNED && (
            <BadgeUnlockModal
              isOpen={celebrationVisible}
              onClose={dismissCelebration}
              badge={currentCelebration.data.badge}
              xpAwarded={currentCelebration.data.badge?.xp_award || 0}
            />
          )}

          {currentCelebration.type === CELEBRATION_TYPES.STREAK_MILESTONE && (
            <StreakCelebration
              isOpen={celebrationVisible}
              onClose={dismissCelebration}
              streakDays={currentCelebration.data.streakDays}
              streakType={currentCelebration.data.streakType || 'daily'}
            />
          )}
        </>
      )}
    </>
  );
};

export default CelebrationOverlay;
